
// SVG Icon: user
export default { id: "terriajs-user" };
export const id = "terriajs-user";
export const name = "user";
